// Opening indexedDB first seems to offer a workaround for safari indexeddb bug
// ref: https://bugs.webkit.org/show_bug.cgi?id=226547

function openDummyIndexedDB() {
  const req = indexedDB.open('dummy', 1);
  req.onblocked = () => {};
  req.onsuccess = () => {};
  req.onerror = () => {};
  req.onupgradeneeded = () => {};
}

openDummyIndexedDB();
